import client from './api-client';

// RG-565 — pantalla "Asignar Abogado" (tarea WFL 15 "Iniciar Gestión Defensa Penal").

export const serviceGetAsistenciasPreliminares = async (query) => {
    try {
        const response = await client.get(`asistencias-preliminares?q=${query}`);
        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } catch (error) {
        throw error;
    }
}

// Reusa el lambda genérico recupero-fnc-proveedores-rol (mismo que "Apoderados" y
// "Gestores Informe"), filtrando por el rol de abogados de defensa penal.
export const serviceGetAbogadosDefensaPenal = async (query) => {
    try {
        const response = await client.get(`proveedores-rol?q=${query}`);
        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } catch (error) {
        throw error;
    }
}

export const servicePostAsignaAbogado = async (body) => {
    try {
        const response = await client.post('asigna-abogado', body);
        return response.data;
    } catch (error) {
        throw error;
    }
}
